module.exports = __webpack_public_path__ + "img/Foto_Tiziana.e8d59fe1.jpg";